import { getProduto } from 'config/produto-env';
import { User } from 'types/user';
import { getCategoriasPreInscricao, hasPapel } from 'utils/pessoa';

export type JourneyProfileType = 'funcionario' | 'participante' | 'gestor';
export type ManagerJourneyStage = 'etapa1' | 'etapa2' | 'etapa3';

const FUNCIONARIO_CHALLENGE_ORDER = [
  'FiwbxsD',
  'FiwbM5P',
  'Fiwb2MF',
  'Fiwcnvh',
  'FiwcAya',
  'FohR25H',
  'FtdwVEB'
];

const PARTICIPANTE_CHALLENGE_ORDER = [
  'FodzghB',
  'FiwbM5P',
  'Fiwb2MF',
  'Fiwcnvh',
  'FiwcAya',
  'FodzBKN',
  'FodzTpb',
  'FodAq4u',
  'FtdwVEB'
];

const GESTOR_CHALLENGE_ORDER: Partial<Record<ManagerJourneyStage, string[]>> = {
  etapa1: [
    'FohRQJm',
    'FiwbM5P',
    'Fiwb2MF',
    'Fiwcnvh',
    'FohR25H',
    'FohSwEF',
    'FohSSjL',
    'FtdwVEB'
  ]
};

const getManagerChallengeOrder = (stage: ManagerJourneyStage): string[] => {
  return GESTOR_CHALLENGE_ORDER[stage] || GESTOR_CHALLENGE_ORDER.etapa1 || [];
};

/**
 * Perfil de jornada: gestor é quem valida a pré-inscrição (`is_manager`),
 * participante é quem tem programa que libera a pré-inscrição no produto,
 * e os demais são funcionários.
 */
export const resolveJourneyProfile = (user?: User | null): JourneyProfileType => {
  const pessoa = user?.pessoa;
  if (hasPapel(pessoa, 'VALIDADOR_PRE_INSCRICAO')) return 'gestor';
  if (getCategoriasPreInscricao(pessoa, getProduto()).length > 0) return 'participante';
  return 'funcionario';
};

export const getJourneyChallengeIds = (
  profile: JourneyProfileType,
  managerStage: ManagerJourneyStage = 'etapa1'
): string[] => {
  if (profile === 'gestor') {
    return getManagerChallengeOrder(managerStage);
  }

  if (profile === 'participante') {
    return PARTICIPANTE_CHALLENGE_ORDER;
  }

  return FUNCIONARIO_CHALLENGE_ORDER;
};

export const filterChallengesByJourneyProfile = <T extends { id: string }>(
  challenges: T[],
  user?: User | null,
  managerStage: ManagerJourneyStage = 'etapa1'
): T[] => {
  const profile = resolveJourneyProfile(user);
  const challengeOrder = getJourneyChallengeIds(profile, managerStage);

  if (!challengeOrder.length) return challenges;

  const orderMap = new Map(challengeOrder.map((challengeId, index) => [challengeId, index]));

  return challenges
    .filter((challenge) => orderMap.has(challenge.id))
    .sort((challengeA, challengeB) => {
      return (orderMap.get(challengeA.id) ?? 0) - (orderMap.get(challengeB.id) ?? 0);
    });
};
